import { Vertical } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';
import { copyright } from 'lib/copyright';

import { Socials } from './Socials';

type Props = { copyrightWrapped?: boolean };
export const Footer = ({ copyrightWrapped }: Props) => {
  return (
    <Vertical style={{ maxWidth: copyrightWrapped ? 200 : undefined }}>
      <Socials />
      <LabelS color="var(--c-nd-600)" className="text-center">
        {copyright}
      </LabelS>
    </Vertical>
  );
};
